import { getEsigningProviderMetadataByProviderId } from 'app/domains/esigning/utils';
const getOrder = (id) => getEsigningProviderMetadataByProviderId(id).properties.selectOrder;
export const getSortedProviders = (providers) => {
    const sort = (a, b) => getOrder(a.id) - getOrder(b.id);
    return [...providers].sort(sort);
};
